
const Capitalize = (text) => {
    return text.toLowerCase().replace(/\b\w/g, function(a){ return a.toUpperCase() });
}

export default Capitalize;